module.exports = __webpack_public_path__ + "static/media/dp-logo-header.e230e64d.png";